"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderInfo = exports.mapCredentialInfo = exports.mapPosInfo = void 0;
const mapPosInfo = (venueId, vendorId, terminalId) => {
    return {
        userName: "",
        userId: 0,
        venueId: +venueId,
        vendorId: +vendorId,
        vendorName: "",
        vendorType: 0,
        vendorRoleId: 0,
        terminalId
    };
};
exports.mapPosInfo = mapPosInfo;
const mapCredentialInfo = (credential, selection, selectionType) => {
    return {
        credential,
        pin: "",
        encoded: true,
        type: "",
        encType: "cnp",
        selection,
        selectionType
    };
};
exports.mapCredentialInfo = mapCredentialInfo;
const mapOrderInfo = (deviceOrderUuid, total, subTotal, discount, tax, currency, items, payments, redemptions) => {
    return {
        orderId: deviceOrderUuid,
        orderUuid: deviceOrderUuid,
        currency: currency !== null && currency !== void 0 ? currency : "",
        total: total,
        subTotal: subTotal,
        remaining: "0",
        discount: discount,
        tax: tax,
        cart: items === null || items === void 0 ? void 0 : items.map((item) => ({
            id: +item.item.id,
            cartItemId: item.item.id,
            sku: item.item.sku,
            itemName: item.item.name,
            itemCost: `${item.item.unitCost}`,
            discount: "0",
            tax: "0",
            quantity: `${item.quantity}`,
            type: item.item.type
        })),
        redemptions,
        payments: payments.map((payment) => {
            return {
                paymentType: payment.paymentType,
                subpaymentType: payment.subpaymentType,
                amount: `${payment.spent}`,
                cartItemIds: items === null || items === void 0 ? void 0 : items.map((item) => item.item.id),
                paymentData: payment.paymentData,
                credentialInfo: (0, exports.mapCredentialInfo)(payment.credential, payment.selection, payment.selectionType)
            };
        })
    };
};
exports.mapOrderInfo = mapOrderInfo;
